import React from 'react';
import { GradientSection, SwipeContainer, SwipeImg } from './styled';
import { images } from '../../../Constants/ImageUrls';

const LactoMamaSwipeWidget = ({ leftOffset }) => {
  return (
    <div>
      <SwipeContainer leftOffset={leftOffset}>
        <SwipeImg src={images.ArrowSlider} />
        <GradientSection />
      </SwipeContainer>
    </div>
  );
};

export default LactoMamaSwipeWidget;
